import { EstadisticasActionTypes } from './constants';

const INIT_STATE = {
    estadistica: {},
    listaEstadisticas: [],
    loading: false,
    error: false,
    formSubmited: false
};

type EstadisticasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { estadistica?: {} | null, listaEstadisticas?: [] | null, loading?: boolean, +value ?: boolean };

const Estadisticas = (state: State = INIT_STATE, action: EstadisticasAction): any => {
    // console.log(action);
    switch (action.type) {
        case EstadisticasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EstadisticasActionTypes.LIST_ESTADISTICAS: {
                    return {
                        ...state,
                        listaEstadisticas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EstadisticasActionTypes.ADD_ESTADISTICA: {
                    return {
                        ...state,
                        estadistica: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EstadisticasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EstadisticasActionTypes.LIST_ESTADISTICAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaEstadisticas: [],
                        loading: false,
                    };
                }
                case EstadisticasActionTypes.ADD_ESTADISTICA: {
                    return {
                        ...state,
                        estadistica: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EstadisticasActionTypes.LIST_ESTADISTICAS:
            return { ...state, error: false, loading: true };
        case EstadisticasActionTypes.ADD_ESTADISTICA:
            return { ...state, error: false, loading: true };
        case EstadisticasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                estadistica: {},
                listaEstadisticas: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Estadisticas;
